<div
  *ngIf="{
    eventTicket: selectedEventTicket$ | async,
    eventTicketProfileMismatch: selectedEventTicketProfileMismatch$ | async,
    selectedStepIndex: selectedStepIndex$ | async,
  } as obs"
  class="gb-event-ticket-accept-dialog"
>
  <gb-event-ticket-guest-stepper
    *ngIf="obs.eventTicket"
    [config]="getStepperConfig(obs.eventTicket, obs.selectedStepIndex)"
    (onSubmitEvent)="onSubmit($event, obs.selectedStepIndex, obs.eventTicket, obs.eventTicketProfileMismatch)"
    #stepper
  >
    <div class="flex-col px-gap-5">
      <gb-callout *ngIf="obs.eventTicketProfileMismatch" color="primary">
        <p>
          <span translate="EVENT_TICKET.ACCEPT_TICKET.ACCEPT_ON_BEHALF_INFO"></span>
          <span
            translate="EVENT_TICKET.ACCEPT_TICKET.ASSIGN_TO_ME_LINK"
            (click)="onAssignToMe()"
            class="primary-link"
          ></span>
          <span translate="EVENT_TICKET.ACCEPT_TICKET.ASSIGN_TO_ME_INFO"></span>
        </p>
      </gb-callout>

      <p
        [innerHTML]="
          'EVENT_TICKET.ACCEPT_TICKET.DESCRIPTION'
            | translate: { ticketPackageName: obs.eventTicket.ticket_package.name }
        "
      ></p>

      <div *ngIf="(displaySocialLogin$ | async) && !isAuthenticated" class="flex-col px-gap-10">
        <gb-social-login-register
          [dialog]="true"
          [redirectHome]="false"
          [onSuccess]="socialLoginSuccessAction"
        ></gb-social-login-register>
        <div class="divider flex-fill flex-row flex-justify-space-between flex-align-center">
          <mat-divider></mat-divider>
          <span translate="AUTH.REGISTER.OR"></span>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>

    <div *ngIf="obs.selectedStepIndex === 0" class="flex-row flex-justify-center px-gap-5" link>
      <span translate="EVENT_TICKET.ACCEPT_TICKET.DECLINE_TEXT"> </span>
      <span
        translate="EVENT_TICKET.ACCEPT_TICKET.DECLINE_LINK"
        (click)="openEventTicketDeclineDialog()"
        [mat-dialog-close]="true"
        class="primary-link"
      >
      </span>
    </div>

    <gb-password-field *ngIf="!isAuthenticated" [control]="password" additionalFields> </gb-password-field>

    <gb-verify-form
      *ngIf="identityReady$ | async"
      [hideSubmitButton]="true"
      [dialog]="true"
      verificationDescription="EVENT_TICKET.ACCEPT_TICKET.VERIFICATION_DESCRIPTION"
      dynamicStep
      #verifyForm
    ></gb-verify-form>
  </gb-event-ticket-guest-stepper>
</div>
